import imgEmptyData from '@/assets/images/empty@2x.png';
import imgEmptySearch from '@/assets/images/empty-search.png';
import imgEmptyList from '@/assets/images/empty-list.png';
export default {
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: 'empty'
    }
  },
  components: {},
  data() {
    return {
      images: {
        empty: imgEmptyData,
        emptySearch: imgEmptySearch,
        emptyList: imgEmptyList
      }
    };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};